export class AntwoordMail {
    constructor(init?: Partial<AntwoordMail>) {
      Object.assign(this, init);
    }

    antwoordtitel: string;
    antwoord: string;
    antwoordFile: string;
    antwoordFileType: string;
}
